import { styled } from "@styles";
import { Card } from "react-bootstrap";

export const Wrapper = styled.div``;

export const OrderFulfillmentCard = styled(Card)`
  margin-bottom: 1rem;
`;

export const OrderFulfillmentHeader = styled(Card.Header)``;

export const OrderFulfillmentBody = styled(Card.Body)``;

export const OrderFulfillment = styled.p`
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  margin: 0;
`;

export const OrderFulfillmentMutedSubtitle = styled.small`
  color: #ddd;
  float: left;
`;